const D = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCAgZD0iTTExIDE4LjU4NlYzaDJ2MTUuNTg2bDYuMjkzLTYuMjkzIDEuNDE0IDEuNDE0TDEyIDIyLjQxNGwtOC43MDctOC43MDcgMS40MTQtMS40MTR6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  D as default
};
//# sourceMappingURL=down-4814eac5.mjs.map
